import { render } from "./PinButton.vue?vue&type=template&id=b9c9bda8"
import script from "./PinButton.vue?vue&type=script&lang=js"
export * from "./PinButton.vue?vue&type=script&lang=js"
script.render = render

export default script